"use client";

import { useEffect, useState } from "react";
import { useTranslations } from "next-intl";
import { domId } from "@/lib/dom-id";
import { Button } from "@/components/ui";

const TOP_OFFSET_TO_SHOW = 260;
// Bottom room page shells keep below their content (the button's 24px offset
// + 48px height + a gap), so once a page is scrolled to its end the floating
// button sits under the page instead of over its last controls (pagination,
// form footers).
export const FLOATING_PAGE_CONTROLS_CLEARANCE_CLASS = "pb-24";
const FLOATING_BUTTON_CLASSNAME =
  "pointer-events-auto inline-flex h-12 w-12 items-center justify-center rounded-full bg-white text-[#00152C] shadow-[0px_8px_24px_rgba(11,8,9,0.12),0px_1px_2px_rgba(11,8,9,0.08)] transition-shadow hover:shadow-[0px_10px_28px_rgba(11,8,9,0.16),0px_1px_2px_rgba(11,8,9,0.08)]";

export default function FloatingPageControls() {
  const t = useTranslations("AppShell.controls");
  const [showTopButton, setShowTopButton] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTopButton(window.scrollY > TOP_OFFSET_TO_SHOW);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!showTopButton) return null;

  const handleBackToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="pointer-events-none fixed bottom-4 right-4 z-40 flex flex-col gap-3 sm:bottom-6 sm:right-6">
      <Button
        data-testid={domId("btn", "floating-back-to-top")}
        type="button"
        onClick={handleBackToTop}
        variant="unstyled"
        className={FLOATING_BUTTON_CLASSNAME}
        title={t("backToTop")}
        aria-label={t("backToTop")}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="h-5 w-5"
        >
          <path d="M12 19V5" />
          <path d="M5 12l7-7 7 7" />
        </svg>
      </Button>
    </div>
  );
}
